import { Component, OnInit, Optional, isDevMode } from "@angular/core";
import { AccountService } from "../../account.service";
import { NzModalRef } from "ng-zorro-antd/modal";
import { isMobileDevice } from "@root/util/util";
import { postMsg } from "@root/router/public/h5/channel/util";
import { Router } from "@angular/router";
import { PlatformType } from "@root/config";

@Component({
  selector: "v4-connect-with-expedia",
  templateUrl: "./connect-with-expedia.component.html",
  styleUrls: ["./connect-with-expedia.component.scss"],
})
export class V4ConnectWithExpediaComponent implements OnInit {
  step = 1;

  username;

  hotelIds = [{ value: null }];

  loading = false;

  footerClass = `
    fixed bottom-[20px] left-[20px] right-[20px] flex flex-col-reverse
    md:flex-row md:justify-end md:relative md:mt-12
  `;
  footerCancelBtnClass = `
    w-full
    md:mr-3 md:w-auto
  `;
  footerConfirmBtnClass = `
    w-full mb-2
    md:mb-0 md:w-auto
  `;

  constructor(
    @Optional() private modalRef: NzModalRef,
    private accountSrv: AccountService,
    private router: Router,
  ) {}

  ngOnInit() {}

  private requestAuth() {
    const params = {
      username: this.username,
      hotel_ids: this.hotelIds?.map((i) => i.value),
    };
    return this.accountSrv.accountAuth("expedia", params);
  }

  onCancel() {
    if (isMobileDevice()) {
      postMsg("BACK");
    } else {
      this.modalRef?.destroy();
    }
  }

  onNext() {
    this.step = this.step + 1;
  }

  onComplete() {
    this.loading = true;
    this.requestAuth().subscribe((rst: any) => {
      this.loading = false;
      if (rst.error_code === 0 || isDevMode()) {
        this.onFinish();
      }
    });
  }

  onFinish() {
    if (isMobileDevice()) {
      this.toH5SuccessPage();
    } else {
      this.modalRef?.destroy("success");
    }
  }

  onRemoveHotelId(index) {
    this.hotelIds.splice(index, 1);
  }

  onAddHotelId() {
    this.hotelIds.push({ value: null });
  }

  private toH5SuccessPage() {
    this.router.navigate(["/app/h5/channel/set-price-ratio"], {
      queryParams: {
        thirdparty_type: PlatformType.Expedia,
      },
    });
  }
}
